module.exports = __webpack_public_path__ + "img/bag1.e135b003.svg";